(function () {
    'use strict';
    //Setting cookie to check whether the browser supports javascript
    document.cookie = "js=true; path=/";

    function creditCalculatorController($scope, contentService, $filter, $timeout) {

        var master = [],
            visible = 0,
            startColor = ['19', '76', 'D2'],
            endColor = ['38', '8e', '3c'],
            sR = parseInt(startColor[0], 16),
            sG = parseInt(startColor[1], 16),
            sB = parseInt(startColor[2], 16),
            eR = parseInt(endColor[0], 16),
            eG = parseInt(endColor[1], 16),
            eB = parseInt(endColor[2], 16);

        this.mappings = [];
        this.externalPrograms = [];

        const interpolate = (begin, end, step) => {
            if (begin < end) {
                return Math.round(((end - begin) * (step / visible)) + begin);
            }
            return Math.round(((begin - end) * (1 - (step / visible))) + end);
        }    

        this.reset = f => {
            this.step = 1;
            this['External program name'] = '';
            this['Institution name'] = '';
            this.filter = f || '';
            this.m = undefined;

            if (master.length) {
                this.mappings = master;
            }
        };

        // back button on panel 
        // reset scope values as required 
        // reset mappings from master - otherwise shows filtered dataset based on previous step selection
        this.back = () => {
            this.step = this.step - 1;

            this.mappings = master.filter(v => 
                v['External program name'] === this['External program name'] && (this.step === 2 || v.institution.name === this['Institution name']));
        };

        this.next = (val, key) => {
            if (val !== undefined) {
                this[key] = val;
            }

            var k = key === 'Institution name' ? key.toLowerCase().split(' '): '';

            this.mappings = this.mappings.filter(v => 
                v[key] === this[key] || (k.length && v[k[0]][k[1]] === this[key]));

            this.step++;
        };


        // set the current displayed mapping
        // fetch the program by matching the program code
        // parse the discipline into a css string
        // advance one step
        this.setMapping = m => {

            if (m['Generic mapping']) {
                window.location = m['Generic mapping'].url;
                return false;
            }

            this.m = m;

            if (m['Date assessed'] !== undefined) {
                this.m['Date assessed'] = $filter('date')(new Date(m['Date assessed']), 'd MMMM yyyy');
            }

            this.hasCourses = m !== undefined && m['USC course credit'] !== undefined && m['USC course credit'].length;

            q = {
                count: 1,
                query: {
                    isArchived: 'n',
                    programCode: m['USC program'].programCode,
                },
            };

            contentService.get(q)
                .then(resp => {
                    this.activeProgram = resp[0];
                });

            this.step++;
        };

        // need to be able to sort by nested properties
        // and by properties with spaces in their key
        this.setSortOrder = arr => {            
            return item => {
                if (item.hasOwnProperty(arr[0])) {
                    arr.forEach(a => item = item[a]);                    
                }

                return item;
            };
        };    

        // set the card colors - can't be done in CSS as card count is unknown
        this.bgColor = i => {
            if (visible) {
                return '#e6edf8'; // Set to your desired color
            }
            return null;
        };


        // clear everything on load
        this.reset();

        $scope.$watchGroup(['calc.filter.length', 'calc.mappings'], (newVal, oldVal) => {
            if (newVal !== oldVal && oldVal !== 0) {
                $timeout(() => visible = $('.mapping:visible').length);
            }
        });

        let q = {
            count: 1,
            query: {
                isArchived: '0',
                url: '"' + document.location.pathname + '"',
            },
            fields: ['creditCalculatorRelations']
        };

        // fetch the data
        // store response in scope and locally for reseting
        contentService.get(q)
            .then(resp => {
 
                master = JSON.parse(resp[0].creditCalculatorRelations).data.filter(x => !x.disabled);

                this.mappings = master;
                this.externalPrograms = $filter('unique')(master, 'External program name', true);
                this.step = 1;
            });
    };


    /* http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key */
    Object.byString = (o, s) => {
        s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
        s = s.replace(/^\./, ''); // strip a leading dot
        var a = s.split('.');

        for (var i = 0, n = a.length; i < n; ++i) {
            var k = a[i];
            if (k in o) {
                o = o[k];
            } else {
                return null;
            }
        }
        return o;
    };

    function uniqueFilter() {
        return function (input, key, stringOnly) {
            if (input) {
                var unique = {},
                    uniqueList = [],
                    o,
                    i;
                
                for (i = 0; i < input.length; i++) {
                    o = Object.byString(input[i], key);
                    if (typeof unique[o] == "undefined") {
                        unique[o] = "";
                        uniqueList.push(input[i]);
                    }
                }
                return stringOnly ? Object.keys(unique) : uniqueList;
            }
            return null;
        };
    };

    angular.module('Uscapp').filter('unique', uniqueFilter);
    angular.module('Uscapp').controller('UscCreditCalculatorController', ['$scope', 'contentService', '$filter', '$timeout', creditCalculatorController]);

})();